import { memo } from 'react';
import { PasswordInput, type PasswordInputProps } from '@adc/parallax-component-library';
import { type GetThemeValueForKey } from '@tamagui/core';

type InputPasswordProps = Omit<
  PasswordInputProps,
  'ariaLabelExtractor' | 'hideButtonAriaLabelExtractor' | 'autoComplete' | 'inputMode' | 'valid'
> & {
  isInvalid?: boolean;
  errorMessage?: string;
  mt?: GetThemeValueForKey<'marginTop'>;
  mb?: GetThemeValueForKey<'marginBottom'>;
  autoComplete?: 'current-password' | 'new-password';
};

const InputPassword = memo(
  ({
    isInvalid = false,
    label = '',
    errorMessage,
    placeholder = '',
    mt,
    mb,
    autoComplete = 'current-password',
    onChangeText,
    testID,
    ...rest
  }: InputPasswordProps) => {
    return (
      <PasswordInput
        label={label}
        valid={isInvalid ? 'no' : 'yes'}
        ariaLabelExtractor={() => ''}
        hideButtonAriaLabelExtractor={() => ''}
        autoComplete={autoComplete}
        marginTop={mt}
        marginBottom={mb}
        placeholder={placeholder}
        onChangeText={onChangeText}
        supportingText={isInvalid ? errorMessage : undefined}
        testID={testID}
        {...rest}
      />
    );
  }
);

InputPassword.displayName = 'InputPassword';

export { InputPassword };
